export default class PreLoaderHandler {

    preloader = $(".preloader");

    constructor() {
    }

    show(){
        const self = this;
        self.preloader.show();
    }

    hide(){
        const self = this;
        self.preloader.fadeOut(750);
    }
}